import httpInstances from '@/api/axiosInstance';
import type { ChartDataRange, ChartDataType } from '@/components/Chart/types/chartData';
import type { ChartType } from '@/components/Chart/types/highcharts';
import type { TemplateChartSeries } from '@/types/charts';
import { downloadJsonFileFromDatalake } from '@/utils/downloadJsonFileFromDatalake';
import { queryApiById } from '@/utils/queryApi';

export type CustomChartDataParams = {
  fileName?: string;
  groupName?: string;
  queryFileId?: string;
  from?: string;
  to?: string;
};

export const chartsApi = {
  getChartData: async (
    templateChartSeries: TemplateChartSeries[],
    chartType: ChartType
  ): Promise<ChartDataType> => {
    const symbols = templateChartSeries.map(({ symbol }) => {
      const clonedSymbol = structuredClone(symbol);
      clonedSymbol.overrideTime = '00:00';
      return clonedSymbol;
    });
    const { data } = await httpInstances.axiosDataInstance.post(
      `/go/index/graph/${chartType === 'forwardSimple' ? 'curve' : chartType}`,
      {
        symbols
      }
    );
    return data;
  },

  getSeasonalChartData: async (
    templateChartSeries: TemplateChartSeries,
    chartDataRange: ChartDataRange
  ): Promise<ChartDataType> => {
    const symbol = structuredClone(templateChartSeries.symbol);
    symbol.from = chartDataRange.from;
    symbol.to = chartDataRange.to;
    const { data } = await httpInstances.axiosDataInstance.post(
      `/go/index/graph/spot/seasonal`,
      symbol
    );
    return data;
  },

  getCustomChartConfig: async (fileName?: string, groupName?: string) => {
    if (!fileName || !groupName) return null;
    return downloadJsonFileFromDatalake(fileName, groupName);
  },

  getCustomChartData: async ({
    fileName,
    groupName,
    queryFileId,
    from,
    to
  }: CustomChartDataParams) => {
    if (queryFileId) {
      return queryApiById(queryFileId, from, to);
    }
    if (fileName && groupName) {
      return downloadJsonFileFromDatalake(fileName, groupName);
    }
    return null;
  }
};
